export enum ZoneCommissionEnum {
  ZONE_A = 'ZONE_A',
  ZONE_B = 'ZONE_B',
}
